import React, {useEffect, useState, useRef} from 'react';
import styles from './index.module.less';
import { useSize } from 'ahooks';
import { useParams } from 'react-router-dom';
import shareAvatar from '../../assets/avatar.png';
import shareBg from '../../assets/share-mobile.png';
import wechat from '../../assets/wechat.png';
import axios from 'axios';
import classes from 'classnames';

const Share = () => {
  const [pictureHeight, setPictureHeight] = useState(0);
  const [shareInfo, setShareInfo] = useState(null);
  const [dataURL, setDataURL] = useState(null);
  const { shareKey } = useParams();
  const canvas = useRef();
  const root = useRef();
  const size = useSize(root);
  useEffect(() => {
    if (!shareKey) {
      return;
    }
    axios.get('/api/course/exchange_share_info', {
      params: {
        share_key: shareKey
      }
    }).then((response) => {
      const { code, data } = response.data;
      if (code === 0) {
        setShareInfo(data.share_info);
      }
    });
  }, [shareKey]);
  useEffect(() => {
    setPictureHeight(canvas.current.offsetWidth * 1.5625);
  }, [size]);
  useEffect(() => {
    if (!canvas.current) {
      return;
    }
    if (pictureHeight === 0) {
      return;
    }
    if (!shareInfo) {
      return;
    }
    const width = pictureHeight / 1.5212121212121212;
    const height = pictureHeight;
    const wRate = (width / 300.0) * 2;
    const hRate = (height / 500) * 2;
    const context = canvas.current.getContext('2d');

    const drawBackground = () => {
      return new Promise((resolve) => {
        const background = new window.Image();
        background.src = shareBg;
        background.setAttribute('crossorigin', 'anonymous');
        background.onload = () => {
          context.drawImage(background, 0, 0, background.width, background.height, 0, 0, width * 2, height * 2 );
          context.fillStyle = 'rgba(0, 0, 0, .3)';
          context.fillRect(0, 0, width * 2, height * 2);
          resolve();
        }
      })
    };
    const drawAvatar = () => {
      return new Promise((resolve) => {
        const avatar = new window.Image();
        avatar.src = shareAvatar;
        avatar.setAttribute('crossorigin', 'anonymous');
        avatar.onload = () => {
          context.drawImage(avatar, 0, 0, avatar.width, avatar.height, 17 * wRate, 34 * hRate, 44 * hRate, 44 * hRate);
        };
        resolve();
      });
    };
    const drawQrCode = () => {
      return new Promise((resolve) => {
        const qrCode = new window.Image();
        qrCode.src = wechat;
        qrCode.setAttribute('crossorigin', 'anonymous');
        qrCode.onload = () => {
          context.drawImage(qrCode, 0, 0, qrCode.width, qrCode.height, 17 * wRate, 400 * hRate, 68 * wRate, 68 * wRate );
          resolve();
        };
      })
    };

    const drawText = () => {
      context.font = `bold ${21 * hRate}px sans-serif`;
      context.fillStyle = '#FFFFFF';
      context.fillText(shareInfo.user_info.user_name, 66 * wRate, 62 * hRate);

      context.font = `bold ${16 * hRate}px sans-serif`;
      context.fillStyle = '#FFFFFF';
      context.fillText('正在学习 ' + shareInfo.course_info.course_name, 17 * wRate, 106 * hRate);

      context.font = `bold ${21 * hRate}px sans-serif`;
      context.fillStyle = '#FFFFFF';
      context.fillText('学习进度 ' + Math.ceil(shareInfo.course_info.learn_progress * 100) + '%', 17 * wRate, 186 * hRate);

      context.fillStyle = '#999999';
      context.fillRect(17 * wRate, 201 * hRate, 260 * wRate, 8 * hRate);

      context.fillStyle = '#FFFFFF';
      context.fillRect(17 * wRate, 201 * hRate, shareInfo.course_info.learn_progress * (260 * wRate), 8 * hRate);

      context.fillStyle = 'rgba(255, 255, 255, 0.2)';
      context.fillRect(17 * wRate, 250 * hRate, 260 * wRate, 101 * hRate);

      context.font = `${16 * hRate}px sans-serif`;
      context.fillStyle = '#FFFFFF';
      context.fillText('学习时长', 45 * wRate, 290 * hRate);
      context.fillText('运行代码', 182 * wRate, 290 * hRate);
      context.fillRect(145 * wRate, 272 * hRate, 2, 60 * hRate);

      context.font = `bold ${21 * hRate}px sans-serif`;
      context.fillText((shareInfo.course_learn_time / 60 / 60).toFixed(2) + '小时', 45 * wRate, 320 * hRate);
      context.fillText(shareInfo.code_line_num + '行', 182 * wRate, 320 * hRate);

      // context.fillRect(17 * wRate, 400 * hRate, 68 * wRate, 68 * wRate);



      context.font = `${14 * hRate}px sans-serif`;
      context.fillStyle = '#FFFFFF';
      context.fillText('扫码添加客服领取编程大礼包', 96 * wRate, 452 * hRate);
      context.fillText('和TA一起学习Python编程吧', 96 * wRate, 472 * hRate);
    };

    drawBackground().then(drawAvatar).then(drawQrCode).then(drawText).then(() => {
      const dataUrl = canvas.current.toDataURL('image/png');
      setDataURL(dataUrl);
    });
  }, [pictureHeight, shareInfo]);
  return (
    <div className={styles.share} ref={root}>
      <div className={styles.main}>
        <div className={styles.tips}>- 长按图片保存并发表朋友圈 -</div>
        {!dataURL && (
          <canvas width={pictureHeight / 1.5625 * 2} height={pictureHeight * 2} style={{ height: pictureHeight }} className={styles.picture} ref={canvas} />
        )}
        {dataURL && (
          <img src={dataURL} crossOrigin='Anonymous' className={classes(styles.picture)} alt=""/>
        )}
      </div>
    </div>
  );
};

export default Share;
